"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontColorMixin = void 0;
var _styledToken = _interopRequireDefault(require("styled-token"));
/** @mixin fontColorMixin */
/**
 * Adds text color styling with the `fontColor` prop.
 *
 * @example
 * import { fontColorMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${fontColorMixin}
 * `;
 *
 * <Component fontColor="textLight">My light text</Component>
 *
 * @method
 * @param {object} props
 * @param {string} [props.fontColor] - A key for the `colors` object on the theme.
 * @param {object} props.theme - The styled-components theme object with a `colors` object.
 * @return {CSSObject}
 */
var fontColorMixin = function fontColorMixin(props) {
  var fontColor = props.fontColor;
  if (!fontColor) {
    return '';
  }
  return (0, _styledToken.default)("colors." + fontColor, function (color) {
    if (color) {
      return "color: " + color + ";";
    }
    return '';
  })(props);
};
exports.fontColorMixin = fontColorMixin;